/**
 * 自動生成された画像を表示するコンポーネント
 */

import { GeneratedImageInfo } from '@/types';
import { Button, Box, Image } from '@chakra-ui/react';
import { useState } from 'react';

interface GeneratedImageProps {
  imageInfo: GeneratedImageInfo;
}

export const GeneratedImage = ({ imageInfo }: GeneratedImageProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(imageInfo.image_url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `generated-image-${imageInfo.image_id}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('画像のダウンロードに失敗しました:', error);
      alert('画像のダウンロードに失敗しました');
    }
  };

  return (
    <Box
      my={4}
      borderRadius="xl"
      border="2px solid"
      borderColor="indigo.200"
      bg="gradientSecondary"
      p={4}
      boxShadow="sm"
    >
      <Box
        position="relative"
        display="flex"
        minH={75}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={3}
        overflow="hidden"
        borderRadius="lg"
        bg="white"
        p={3}
      >
        {!imageError ? (
          <>
            {!imageLoaded && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={3}
                py={10}
                fontSize="sm"
                color="gray.600"
              >
                <Box
                  w={8}
                  h={8}
                  animation="spin"
                  borderRadius="full"
                  border="3px solid"
                  borderColor="gray.300"
                  borderTopColor="indigo.500"
                ></Box>
                <span>画像を読み込んでいます...</span>
              </Box>
            )}
            <Image
              src={imageInfo.image_url}
              alt={imageInfo.prompt}
              h="auto"
              w="full"
              maxW="lg"
              borderRadius="lg"
              transition="opacity 0.3s"
              opacity={imageLoaded ? 1 : 0}
              display={imageLoaded ? 'block' : 'none'}
              onLoad={handleImageLoad}
              onError={handleImageError}
            />
            {imageLoaded && (
              <Button
                variant="gradient-primary"
                size="sm"
                onClick={handleDownload}
                title="画像をダウンロード"
                gap={1.5}
              >
                ⬇ ダウンロード
              </Button>
            )}
          </>
        ) : (
          <Box
            py={10}
            textAlign="center"
            fontSize="sm"
            fontWeight="medium"
            color="semantics.errorDark"
          >
            <span>画像の読み込みに失敗しました</span>
          </Box>
        )}
      </Box>
    </Box>
  );
};
